import { SharedConfig as Config } from "./types";

let globalConfig: Config | null = null;

export function setSharedConfig(config: Config) {
  globalConfig = config;
}

function getConfig(): Config {
  if (!globalConfig) {
    return {
      appUrl: process.env.APP_URL,
      apiUrl: process.env.API_URL || "https://api.sandbox.qfast.id",
      stand: process.env.STAND,
      faviconUrl: `/favicon.ico`,
    };
  }
  return globalConfig as Config;
}

export function createSharedConfigService(): { config: Config } {
  const config = getConfig();

  return {
    config,
  }
}